var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editorial-slider",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-duration": "400",
        "data-aos-easing": "ease-in-out"
      }
    },
    [
      _c("div", { ref: "editorialSwiper", staticClass: "swiper-container" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.images, function(image, index) {
            return _c("div", {
              key: index,
              staticClass: "swiper-slide lazyload",
              class: { outline: _vm.hasoutline },
              attrs: { "data-sizes": "auto", "data-bgset": image }
            })
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
      _vm._v(" "),
      _c("div", { ref: "next", staticClass: "swiper-button-next" }),
      _vm._v(" "),
      _vm.stamp.stamp_show
        ? _c("stamp", { attrs: { stamp: _vm.stamp } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }